module.exports = __webpack_public_path__ + "img/banner.2ae7a3bf.png";